import { Graphics } from 'pixi.js'

export default class makeGraphics extends Graphics{
  constructor(data) {
    super()
    this.beginFill(data.color)
    this.alpha = data.alpha == undefined ? 1 : data.alpha

    if (data.polygon) {
      this.drawPolygon(data.polygon)
    }
    else if (data.round) {
      this.drawRoundedRect(0, 0, data.width, data.height, data.round)
    }
    else {
      this.drawRect(0, 0, data.width, data.height)
    }

    this.endFill()
  }
}
